module.exports = __webpack_public_path__ + "static/media/new-notification.b0cdbb11.svg";